import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from './services'
import './registerServiceWorker'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'
import Vuetify from 'vuetify'
// import VueMoment from 'vue-moment'
import pt from 'vuetify/lib/locale/pt'

import VueApexCharts from 'vue-apexcharts'

ApiService.init()

Vue.component('apexchart', VueApexCharts)

Vue.use(require('vue-moment'))

Vue.use(Vuetify, {
  theme: {
    primary: '#002857', // #E53935
    secondary: colors.grey.lighten4, // #FFCDD2
    accent: colors.blueGrey.base, // #3F51B5
    error: colors.red.base
  },
  lang: {
    locales: { pt },
    current: 'pt'
  }
})

router.beforeEach((to, from, next) => {
  store.dispatch('request/verifyAuth').then(() => {
    next()
  })
})

new Vue({
  router,
  store,
  Vuetify,
  render: h => h(App)
}).$mount('#app')
